<template>
  <div style="width: 100%;" class="flex">
    <div class="content">
      <div class="left">
        <div class="title">院校排行榜</div>
        <div class="choose">
          <!-- <div :class="current==1?'active':''" @click="changecurrent(1)">院校排名</div> -->
          <div :class="current==2?'active':''" @click="changecurrent(2)">软科排名</div>
          <div :class="current==3?'active':''" @click="changecurrent(3)">校友会排名</div>
          <div :class="current==4?'active':''" @click="changecurrent(4)">武书连排名</div>
          <div :class="current==5?'active':''" @click="changecurrent(5)">US_NEWS世界排名</div>
          <div :class="current==6?'active':''" @click="changecurrent(6)">金苹果排名</div>
          <!-- <div :class="current==4?'active':''" @click="changecurrent(4)">野鸡大学</div> -->
        </div>
      </div>
      <div class="right">
        <div class="bg">
          {{name}}
        </div>
        <div class="filter flex">
          <el-dropdown trigger="click" v-show="current==2">
            <span class="el-dropdown-link">
              {{filter_title}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,index) in filter_type" :key="index" @click.native="filter(item)">{{item}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div style="margin-left: 15px;width: 447px;">
            <el-input placeholder="请输入院校名" v-model="keyword">
              <el-button slot="append" icon="el-icon-search" @click="search()">搜索</el-button>
            </el-input>
          </div>

        </div>
        <!-- 院校综合排名 -->
        <!-- <div class="schoolList" v-if="current==1">
          <div class="one flex" v-for="(item,index) in data" @click="jumpdetail(item)" :key="index">
            <div class="flex">
              <span class="rank"
                style="height: 44px;width: 32px;display: inline-block;line-height: 44px;color: #999999;font-size: 22px;">{{item.rank}}</span>
              <img :src="item.badge_img" style="margin:0 20px;">
            </div>
            <div class="info">
              <div><span class="name">{{item.name}}</span></div>
              <div v-if="item.info" class="lei"><span>{{item.info.city_name}}</span></div>
              <div v-if="item.info!=null" class="lei">
                <span v-if="item.info.type!=null">{{item.info.type}}</span>
                <span v-if="item.info.renown!=null">{{item.info.renown}}</span>
                <span v-if="item.info.classic!=null">{{item.info.classic}}</span>
                <span>{{item.type}}</span>
                <span v-if="item.info.is_211">
                  {{item.info.is_211==1?'211':''}}
                </span>
                <span v-if="item.info.is_985">
                  {{item.info.is_985==1?'985':''}}
                </span>
              </div>
              <div class="url" v-if="item.info&&item.info.school_url">学校官网：<span
                  @click.stop="openUrl(item.info.school_url)">{{item.info.school_url}}</span></div>
            </div>
          </div>
        </div> -->
        <!-- 院校综合排名结束 ！！！！！！！！！！！！！！！！！！！！！！！-->

        <!-- 软科排名 ！！！！！！！！！！！！！！！！！！！！！！！！！！！！！-->
        <div class="schoolList" v-if="current==2">
          <div class="one flex" v-for="(item,index) in data" @click="jumpdetail(item)">
            <div class="flex">
              <!--   <img v-if="item.rank==1" style="height: 44px;width: 32px;" src="../../assets/school/no1.png">
                <img v-if="item.rank==2" style="height: 44px;width: 32px;" src="../../assets/school/no2.png">
                <img v-if="item.rank==3" style="height: 44px;width: 32px;" src="../../assets/school/no3.png"> -->
              <span class="rank"
                style="height: 44px;width: 32px;display: inline-block;line-height: 44px;color: #999999;font-size: 22px;">{{item.rank}}</span>
              <img :src="item.badge_img" style="margin:0 20px;">
            </div>
            <div class="info">
              <div><span class="name">{{item.school_name}}</span></div>
              <div v-if="item.info" class="lei"><span>{{item.info.city_name}}</span></div>
              <div v-if="item.info!=null" class="lei">
                <span v-if="item.info.type!=null">{{item.info.type}}</span>
                <span v-if="item.info.renown!=null">{{item.info.renown}}</span>
                <span v-if="item.info.classic!=null">{{item.info.classic}}</span>
                <span>{{item.type}}</span>
                <span v-if="item.info.is_211">
                  {{item.info.is_211==1?'211':''}}
                </span>
                <span v-if="item.info.is_985">
                  {{item.info.is_985==1?'985':''}}
                </span>
                <div class="url" v-if="item.info&&item.info.school_url">学校官网：<span
                    @click.stop="openUrl(item.info.school_url)">{{item.info.school_url}}</span></div>
              </div>
            </div>

            <!-- <div class="address">北京市海淀区</div> -->
          </div>
        </div>
        <!-- 软科排名结束 -->


        <!-- 校友会排名 -->
        <div class="schoolList" v-if="current==3">
          <div class="one flex" v-for="(item,index) in data" @click="jumpdetail(item)">
            <div class="flex">
              <!--   <img v-if="item.rank==1" style="height: 44px;width: 32px;" src="../../assets/school/no1.png">
              <img v-if="item.rank==2" style="height: 44px;width: 32px;" src="../../assets/school/no2.png">
              <img v-if="item.rank==3" style="height: 44px;width: 32px;" src="../../assets/school/no3.png"> -->
              <span class="rank"
                style="height: 44px;width: 32px;display: inline-block;line-height: 44px;color: #999999;font-size: 22px;">{{item.rank}}</span>
              <img :src="item.badge_img" style="margin:0 20px;">
            </div>
            <div class="info">
              <div><span class="name">{{item.school_name}}</span></div>
              <div v-if="item.info" class="lei"><span>{{item.info.city_name}}</span></div>
              <div v-if="item.info!=null" class="lei">
                <span v-if="item.info.type!=null">{{item.info.type}}</span>
                <span v-if="item.info.renown!=null">{{item.info.renown}}</span>
                <span v-if="item.info.classic!=null">{{item.info.classic}}</span>
                <span>{{item.type}}</span>
                <span v-if="item.info.is_211">
                  {{item.info.is_211==1?'211':''}}
                </span>
                <span v-if="item.info.is_985">
                  {{item.info.is_985==1?'985':''}}
                </span>
                <div class="url" v-if="item.info&&item.info.school_url">学校官网：<span
                    @click.stop="openUrl(item.info.school_url)">{{item.info.school_url}}</span></div>
              </div>
            </div>
            <!-- <div class="url" v-if="item.info&&item.info.school_url">学校官网：<span
                    @click.stop="openUrl(item.info.school_url)">{{item.info.school_url}}</span></div>
              </div> -->
          </div>

        </div>
        <!-- 校友会排名 -->

        <!-- 武书连排名 -->
        <div class="schoolList" v-if="current==4">
          <div class="one flex" v-for="(item,index) in data" @click="jumpdetail(item)">
            <div class="flex">
              <!--   <img v-if="item.rank==1" style="height: 44px;width: 32px;" src="../../assets/school/no1.png">
              <img v-if="item.rank==2" style="height: 44px;width: 32px;" src="../../assets/school/no2.png">
              <img v-if="item.rank==3" style="height: 44px;width: 32px;" src="../../assets/school/no3.png"> -->
              <span class="rank"
                style="height: 44px;width: 32px;display: inline-block;line-height: 44px;color: #999999;font-size: 22px;">{{item.rank}}</span>
              <img :src="item.badge_img" style="margin:0 20px;">
            </div>
            <div class="info">
              <div><span class="name">{{item.school_name}}</span></div>
              <div v-if="item.info" class="lei"><span>{{item.info.city_name}}</span></div>
              <div v-if="item.info!=null" class="lei">
                <span v-if="item.info.type!=null">{{item.info.type}}</span>
                <span v-if="item.info.renown!=null">{{item.info.renown}}</span>
                <span v-if="item.info.classic!=null">{{item.info.classic}}</span>
                <span>{{item.type}}</span>
                <span v-if="item.info.is_211">
                  {{item.info.is_211==1?'211':''}}
                </span>
                <span v-if="item.info.is_985">
                  {{item.info.is_985==1?'985':''}}
                </span>
                <div class="url" v-if="item.info&&item.info.school_url">学校官网：<span
                    @click.stop="openUrl(item.info.school_url)">{{item.info.school_url}}</span></div>
              </div>
            </div>
            <!-- <div class="url" v-if="item.info&&item.info.school_url">学校官网：<span
                    @click.stop="openUrl(item.info.school_url)">{{item.info.school_url}}</span></div>
              </div> -->
          </div>
        </div>

        <!-- US_NEWS世界排名 -->
        <div class="schoolList" v-if="current==5">
          <div class="one flex" v-for="(item,index) in data" @click="jumpdetail(item)">
            <div class="flex">
              <!--   <img v-if="item.rank==1" style="height: 44px;width: 32px;" src="../../assets/school/no1.png">
              <img v-if="item.rank==2" style="height: 44px;width: 32px;" src="../../assets/school/no2.png">
              <img v-if="item.rank==3" style="height: 44px;width: 32px;" src="../../assets/school/no3.png"> -->
              <span class="rank"
                style="height: 44px;width: 32px;display: inline-block;line-height: 44px;color: #999999;font-size: 22px;">{{item.rank}}</span>
              <img :src="item.badge_img" style="margin:0 20px;">
            </div>
            <div class="info">
              <div><span class="name">{{item.school_name}}</span></div>
              <div v-if="item.info" class="lei"><span>{{item.info.city_name}}</span></div>
              <div v-if="item.info!=null" class="lei">
                <span v-if="item.info.type!=null">{{item.info.type}}</span>
                <span v-if="item.info.renown!=null">{{item.info.renown}}</span>
                <span v-if="item.info.classic!=null">{{item.info.classic}}</span>
                <span>{{item.type}}</span>
                <span v-if="item.info.is_211">
                  {{item.info.is_211==1?'211':''}}
                </span>
                <span v-if="item.info.is_985">
                  {{item.info.is_985==1?'985':''}}
                </span>
                <div class="url" v-if="item.info&&item.info.school_url">学校官网：<span
                    @click.stop="openUrl(item.info.school_url)">{{item.info.school_url}}</span></div>
              </div>
            </div>
            <!-- <div class="url" v-if="item.info&&item.info.school_url">学校官网：<span
                    @click.stop="openUrl(item.info.school_url)">{{item.info.school_url}}</span></div>
              </div> -->
          </div>
        </div>

        <!-- 金苹果-->
        <div class="schoolList" v-if="current==6">
          <div class="one flex" v-for="(item,index) in data" @click="jumpdetail(item)">
            <div class="flex">
              <!--   <img v-if="item.rank==1" style="height: 44px;width: 32px;" src="../../assets/school/no1.png">
              <img v-if="item.rank==2" style="height: 44px;width: 32px;" src="../../assets/school/no2.png">
              <img v-if="item.rank==3" style="height: 44px;width: 32px;" src="../../assets/school/no3.png"> -->
              <span class="rank"
                style="height: 44px;width: 32px;display: inline-block;line-height: 44px;color: #999999;font-size: 22px;">{{item.rank}}</span>
              <img :src="item.badge_img" style="margin:0 20px;">
            </div>
            <div class="info">
              <div><span class="name">{{item.school_name}}</span></div>
              <div v-if="item.info" class="lei"><span>{{item.info.city_name}}</span></div>
              <div v-if="item.info!=null" class="lei">
                <span v-if="item.info.type!=null">{{item.info.type}}</span>
                <span v-if="item.info.renown!=null">{{item.info.renown}}</span>
                <span v-if="item.info.classic!=null">{{item.info.classic}}</span>
                <span>{{item.type}}</span>
                <span v-if="item.info.is_211">
                  {{item.info.is_211==1?'211':''}}
                </span>
                <span v-if="item.info.is_985">
                  {{item.info.is_985==1?'985':''}}
                </span>
                <div class="url" v-if="item.info&&item.info.school_url">学校官网：<span
                    @click.stop="openUrl(item.info.school_url)">{{item.info.school_url}}</span></div>
              </div>
            </div>
            <!-- <div class="url" v-if="item.info&&item.info.school_url">学校官网：<span
                    @click.stop="openUrl(item.info.school_url)">{{item.info.school_url}}</span></div>
              </div> -->
          </div>
        </div>
      </div>
    </div>
    <el-pagination background layout="prev, pager, next" page-size="20" :total="total"
      style="margin: 60px auto 40px auto;" @current-change="current_change" v-if="pageshow">
    </el-pagination>
  </div>
  </div>
  </div>




</template>

<script>
  export default {
    data() {
      return {
        data: [{
          info: {}
        }],
        filter_title: '综合排名',
        current: 2,
        name: '软科排名',
        total: 0,
        page: 1,
        pageshow: true,
        keyword: '',
        filter_type: ['综合排名',
          '医药类',
          '财经类',
          '语言类',
          '政法类',
          '民族类',
          '体育类',
          '艺术类',
          '理工类',
          '师范类',
          '农林类',
          '综合类',
          '合作办学',
          '民办高校',
        ]
      }
    },
    mounted() {
      this.$http.schoolRankScience({
        per: 20
      }).then(res => {
        this.data = res.data.list
        this.total = res.data.count
      })
    },
    methods: {
      search() {
        console.log(this.current)
        if (this.current == 2) {
          this.$http.schoolRankScience({
            per: 20,
            page: this.page,
            type: this.filter_title,
            name: this.keyword
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count
          })
        }
        if (this.current == 3) {
          this.$http.schoolRankAlumni({
            per: 20,
            page: this.page,
            name: this.keyword
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count
          })
        }
        if (this.current == 4) {
          this.$http.schoolRankOthers({
            per: 20,
            page: this.page,
            type: '武书连',
            name: this.keyword
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count
          })
        }
        if (this.current == 5) {
          this.name = 'US_NEWS世界排名'
          this.$http.schoolRankOthers({
            per: 20,
            page: this.page,
            type: 'US_NEWS世界排名',
            name: this.keyword
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count
          })
        }
        if (this.current == 6) {
          this.name = '金苹果排名'
          this.$http.schoolRankOthers({
            per: 20,
            page: this.page,
            type: '金苹果排名',
            name: this.keyword
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count
            console.log(this.data)
          })
        }
      },
      current_change(e) {
        this.page = e
        if (this.current == 1) {
          this.$http.schoolRank({
            per: 20,
            page: this.page,
            name: this.keyword
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count
          })
        }
        if (this.current == 2) {
          this.$http.schoolRankScience({
            per: 20,
            page: this.page,
            type: this.filter_title,
            name: this.keyword
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count
          })
        }
        if (this.current == 3) {
          this.$http.schoolRankAlumni({
            per: 20,
            page: this.page,
            name: this.keyword
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count
          })
        }
        if (this.current == 4) {
          this.$http.schoolRankOthers({
            per: 20,
            page: this.page,
            type: '武书连',
            name: this.keyword
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count
          })
        }
        if (this.current == 5) {
          this.name = 'US_NEWS世界排名'
          this.$http.schoolRankOthers({
            per: 20,
            page: this.page,
            type: 'US_NEWS世界排名',
            name: this.keyword
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count
          })
        }
        if (this.current == 6) {
          this.name = '金苹果排名'
          this.$http.schoolRankOthers({
            per: 20,
            page: this.page,
            type: '金苹果排名',
            name: this.keyword
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count
            console.log(this.data)
          })
        }
      },
      filter(item) {
        this.page = 1
        this.filter_title = item
        this.$http.schoolRankScience({
          per: 20,
          page: this.page,
          type: item,
          name: this.keyword
        }).then(res => {
          this.data = res.data.list
          this.total = res.data.count
        })
      },
      jumpdetail(item) {
        this.$router.push(`schoolDetail?id=${item.school_id}`)
      },
      changecurrent(num) {
        this.current = num
        this.keyword = ''
        this.page = 1
        this.pageshow = false
        if (num == 2) {
          this.name = '软科排名'
          this.$http.schoolRankScience({
            per: 20,
            page: 1,
            type: this.filter_title,
            name: this.keyword
          }).then(res => {
            this.data = res.data.list
          })
        }
        if (num == 3) {
          this.name = '校友会排名'
          this.$http.schoolRankAlumni({
            per: 20,
            page: 1,
            type: this.filter_title,
            name: this.keyword
          }).then(res => {
            this.data = res.data.list
          })
        }
        if (this.current == 4) {
          this.name = '武书连排名'
          this.$http.schoolRankOthers({
            per: 20,
            page: this.page,
            type: '武书连',
            name: this.keyword
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count
          })
        }
        if (this.current == 5) {
          this.name = 'US_NEWS世界排名'
          this.$http.schoolRankOthers({
            per: 20,
            page: this.page,
            type: 'US_NEWS世界排名',
            name: this.keyword
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count
          })
        }
        if (this.current == 6) {
          this.name = '金苹果排名'
          this.$http.schoolRankOthers({
            per: 20,
            page: this.page,
            type: '金苹果排名',
            name: this.keyword
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count
          })

        }
        this.$nextTick(() => { //重新渲染分页
          this.pageshow = true;
        });
      },
      openUrl(url) {
        window.open(url)
      }
    }
  }
</script>

<style scoped lang="scss">
  .url {
    margin-top: 10px;
    color: #999999;

    span {
      cursor: pointer;
    }

    span:hover {
      color: #004adf;
    }
  }

  .info {
    .lei {
      margin-top: 10px;
      color: #999999;
      font-size: 12px;

      span {
        margin-right: 10px;
      }
    }
  }

  .right {
    margin-left: 300px;

    .bg {
      text-align: center;
      width: 100%;
      height: 78px;
      line-height: 65px;
      color: #FFFFFF;
      font-size: 26px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      background: url(../../assets/school/bg2.png) 100% 100%;
      background-size: cover;
    }
  }

  .left {
    width: 251px;
    float: left;

    .active {
      background-color: #C10B17;
      color: #FFFFFF;
    }

    .choose {
      margin-top: 18px;
      width: 251px;
      background: #FFFFFF;
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
      border-radius: 10px;

      div {
        height: 50px;
        line-height: 50px;
        text-align: left;
        text-indent: 20px;
      }
    }
  }

  .content {
    width: 1280px;
    margin: 20px auto;
  }

  .one {
    .info1 {
      margin-left: 68px;

      img {
        width: 20px;
        height: 20px;
        margin-top: 16px;
      }
    }

    text-align: left;
    border-bottom: 1px solid #F2F2F2;
    padding-bottom: 17px;
    margin-top:20px;

    button {
      width: 74px;
      height: 32px;
      background: #C10B17;
      border-radius: 4px;
      border: none;
      font-weight: 400;
      color: #FFFFFF;
      margin-left: 240px;
    }

    img {
      width: 67px;
      height: 67px;
      border-radius: 50%;
      margin-right: 12px;
    }

    .type {
      margin-top: 12px;
    }

    .type span {
      margin-top: 32px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      background: #F2F2F2;
      border-radius: 11px;
      padding: 2px 10px;
    }



    .name {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-right: 29px;
      margin-bottom: 20px;
    }

    .address {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      margin-left: 430px;
    }
  }

  .schoolList {
    margin: 40px 0;

    .filter {
      text-align: left;

      span {
        font-size: 16px;
        cursor: context-menu;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/school/rank.vue